import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

export function spSlider() {
  window.addEventListener(
    'DOMContentLoaded',
    () => {
      if (document.querySelector('.js-sliderSp')) {
        // option は使い回すので別に書く
        const options = {
          modules: [Navigation, Autoplay],
          effect: 'fade',
          loop: true,
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        };
        const breakPoint = 767;
        let spSwiper;
        if (window.innerWidth <= breakPoint) {
          spSwiper = new Swiper('.js-sliderSp', options);
        } else {
          spSwiper = undefined;
        }
        window.addEventListener(
          'resize',
          () => {
            if (window.innerWidth <= breakPoint) {
              if (spSwiper) return;
              spSwiper = new Swiper('.js-sliderSp', options);
            } else {
              if (!spSwiper) return;
              spSwiper.destroy();
              spSwiper = undefined;
            }
          },
          false
        );
      }
    },
    false
  );
}
